<template>
  <div class="field orderby">
    <label class="label sort-label heading-4 is-lighter" :for="orderBy">Order</label>
    <div class="select control">
      <select :name="orderBy" v-model="orderBy">
        <option value="lastName asc">A &#x2192; Z</option>
        <option value="lastName desc">Z &#x2192; A</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    namespace: String
  },
  computed: {
    orderBy: {
      get () {
        return this.$store.state[this.namespace].orderBy
      },
      set (value) {
        this.$store.commit(this.namespace + '/UPDATE_ORDER', value)
      }
    }
  }
}
</script>
